import axios from 'axios';

const BITLY_HEADER = {
  headers: {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_BITLY_ACCESS_TOKEN}`,
    'Content-Type': 'application/json',
  },
};

interface CreateBitlinksParams {
  longUrl: string;
  title?: string;
  // appUriPath?: string; // 앱에서 처리할 URI path (ex: "/product/123")
}

export const createBitlinks = async ({
  longUrl,
  title,
}: CreateBitlinksParams) => {
  const separator = longUrl.includes('?') ? '&' : '?';
  const uniqueUrl = `${longUrl}${separator}_t=${Date.now()}`;

  const { data } = await axios.post(
    'https://api-ssl.bitly.com/v4/bitlinks',
    {
      long_url: uniqueUrl,
      domain: process.env.NEXT_PUBLIC_BITLY_DOMAIN,
      group_guid: process.env.NEXT_PUBLIC_BITLY_GUID,
      ...(title && { title }),
      force_new_link: true,
    },
    BITLY_HEADER
  );

  return data; // data.link 가 short link
};

export const postBitlyShortLink = async ({ longUrl }: CreateBitlinksParams) => {
  const { data } = await axios.post<{ link: string }>(
    'https://api-ssl.bitly.com/v4/shorten',
    {
      long_url: longUrl,
      domain: process.env.NEXT_PUBLIC_BITLY_DOMAIN,
      group_guid: process.env.NEXT_PUBLIC_BITLY_GUID,
    },
    BITLY_HEADER
  );
  return data;
};
